<template>
  <div class="vx-col w-full">
    <vx-card title="Applicant Personal Information (আবেদনকারীর ব্যক্তিগত তথ্য)">
      <br>
      <form data-vv-scope="step-1">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Applicant’s Name (with Nick Name) -আবেদনকারীর নাম (ডাক নাম সহ)<sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" type="text" v-validate="'required'" @keypress="isLetter" data-vv-as="first name"
                          v-model="personal.applicantName" name="personal.applicantName"/>
                <span class="text-danger text-sm" v-show="errors.has('personal.applicantName')">{{ errors.first('personal.applicantName') }}</span>
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Last Name (নামের শেষাংশ) <sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input v-validate="'required'" @keypress="isLetter" class="w-full" type="text" data-vv-as="last name"
                          v-model="personal.lastName" name="personal.lastName"/>
                <span class="text-danger text-sm" v-show="errors.has('personal.lastName')">{{ errors.first('personal.lastName') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Father’s Name (পিতার নাম) <sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input v-validate="'required'" @keypress="isLetter" class="w-full" type="text" data-vv-as="father name"
                          v-model="personal.fathersName" name="personal.fathersName"/>
                <span class="text-danger text-sm" v-show="errors.has('personal.fathersName')">{{ errors.first('personal.fathersName') }}</span>
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Mother’s Name (মাতার নাম) <sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input v-validate="'required'" @keypress="isLetter" class="w-full" type="text" data-vv-as="mother name"
                          v-model="personal.motherName" name="personal.motherName"/>
                <span class="text-danger text-sm" v-show="errors.has('personal.motherName')">{{ errors.first('personal.motherName') }}</span>
              </div>
            </div>
          </div>

        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Age (বয়স) <sup>*</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="age" v-model="personal.age" vs-value="18-25"
                              name="personal.age">18-25
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="age" v-model="personal.age" vs-value="26-35"
                              name="personal.age">26-35
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="age" v-model="personal.age" vs-value="36-45"
                              name="personal.age">36-45
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="age" v-model="personal.age" vs-value="46-55"
                              name="personal.age">46-55
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="age" v-model="personal.age" vs-value="56-65"
                              name="personal.age">56-65
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="age" v-model="personal.age" vs-value="66+"
                              name="personal.age">66+
                    </vs-radio>
                  </li>
                </ul>
                <span class="text-danger text-sm"
                      v-show="errors.has('personal.age')">{{ errors.first('personal.age') }}</span>
                <!--<datepicker placeholder="Select Date" v-model="birthDate"></datepicker>-->
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-4">
                <span>Gender (লিঙ্গ) <sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="gender" v-model="personal.gender" vs-value="Male"
                              name="personal.gender">Male
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="gender" v-model="personal.gender" vs-value="Female"
                              name="personal.gender">Female
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="gender" v-model="personal.gender" vs-value="Others"
                              name="personal.gender">Others
                    </vs-radio>
                  </li>
                </ul>
                <span class="text-danger text-sm" v-show="errors.has('personal.gender')">{{ errors.first('personal.gender') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-4">
                <span>Marital Status (বৈবাহিক অবস্থা) <sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="marital status" v-model="personal.maritalStatus"
                              vs-value="Single" name="personal.maritalStatus">Single
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="marital status" v-model="personal.maritalStatus"
                              vs-value="Married" name="personal.maritalStatus">Married
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="marital status" v-model="personal.maritalStatus"
                              vs-value="Separated" name="personal.maritalStatus">Separated
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="marital status" v-model="personal.maritalStatus"
                              vs-value="Divorced" name="personal.maritalStatus">Divorced
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="marital status" v-model="personal.maritalStatus"
                              vs-value="Widowed" name="personal.maritalStatus">Widowed
                    </vs-radio>
                  </li>
                </ul>
                <span class="text-danger text-sm" v-show="errors.has('personal.maritalStatus')">{{ errors.first('personal.maritalStatus') }}</span>
              </div>
            </div>
          </div>
          <div v-if="personal.maritalStatus !== 'Single'" class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Spouse Name (স্বামী বা স্ত্রীর নাম) <sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input :disabled="personal.maritalStatus === 'Single'" v-validate="'required'" data-vv-as="spouse name"
                          class="w-full" type="text"
                          v-model="personal.spouseName" name="personal.spouseName"/>
                <span class="text-danger text-sm" v-show="errors.has('personal.spouseName')">{{ errors.first('personal.spouseName') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-4">
                <span>Head of Household ? (সংসার প্রধান? ) <sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="head of household" v-model="personal.headOfHousehold"
                              :vs-value="true" name="personal.headOfHousehold">Yes
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-validate="'required'" data-vv-as="head of household" v-model="personal.headOfHousehold"
                              :vs-value="false" name="personal.headOfHousehold">No
                    </vs-radio>
                  </li>
                </ul>
                <span class="text-danger text-sm" v-show="errors.has('personal.headOfHousehold')">{{ errors.first('personal.headOfHousehold') }}</span>
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-4">
                <span>Education Level (শিক্ষাগত যোগ্যতা ) <sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <template>
                  <v-select label="text" v-validate="'required'" data-vv-as="education level" v-model="personal.education"
                            class="w-full select-large"
                            :options="educationLevelOpt" :dir="$vs.rtl ? 'rtl' : 'ltr'" name="personal.education"/>
                </template>
                <span class="text-danger text-sm" v-show="errors.has('personal.education')">{{ errors.first('personal.education') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>NID No (জাতীয় পরিচয়পত্র নং) <sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input  class="w-full" type="text" v-validate="'required|greaterThanZero|min:10|max:17'" data-vv-as="NID No" @keypress="onlyNidNumber"
                          v-model="personal.nidNo"
                          name="personal.nidNo"/>
                <span class="text-danger text-sm" v-show="errors.has('personal.nidNo')">{{ errors.first('personal.nidNo') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-16">
                <span>Nid Front (Max 300 KB) (জাতীয় পরিচয়পত্রের সামনের দিক) <sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mt-16">
                <div v-if="nidFrontUrl" class="preview-image">
                  <img  :src="nidFrontUrl"/>
                  <span @click="removeNidFront">X</span>
                </div>
                <label v-if="nidFrontUrl === ''" class="custom-file-upload">
                  <input type="file"  data-vv-as="NID Front" class="uploadBtn" required @change="successNidFrontUpload" name="personal.nidFrontImage"> Nid Front
                </label>
                <span class="text-danger text-sm" v-show="errors.has('personal.nidFrontImage')">{{ errors.first('personal.nidFrontImage') }}</span>
                <!--<template>
                  <vs-upload  :data="personal.nidFrontImage" fileName="nidFront" text="NID Front" @change="successNidUpload"/>
                </template>-->
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-16">
                <span>Nid Back (Max 300 KB) (জাতীয় পরিচয়পত্রের পেছনের দিক)<sup>*</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mt-16">
                <div v-if="nidBackUrl" class="preview-image">
                  <img  :src="nidBackUrl"/>
                  <span @click="removeNidBack">X</span>
                </div>
                <label v-if="nidBackUrl === ''" class="custom-file-upload">
                  <input type="file"  data-vv-as="NID Back" name="personal.nidBackImage" class="uploadBtn" required @change="successNidBackUpload"> Nid Back
                </label>
                <span class="text-danger text-sm" v-show="errors.has('personal.nidBackImage')">{{ errors.first('personal.nidBackImage') }}</span>
                <!--<input type="file" @change="successNidBanckUpload">-->
                <!--<template>
                  <vs-upload text="NID Back"
                             @on-success="successNidUpload"/>
                </template>-->
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-16">
                <span>Upload Photo (Max 300 KB) (ব্যাক্তিগত ছবি আপলোড করুন )<sup> *</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mt-16">
                <div v-if="applicantPhotoUrl" class="preview-image">
                  <img :src="applicantPhotoUrl"/>
                  <span @click="removePhoto">X</span>
                </div>
                <label v-if="applicantPhotoUrl === ''" class="custom-file-upload-app">
                  <input type="file"  data-vv-as="Photo" name="personal.applicantPhoto" class="uploadBtn" required @change="successAppPhotoUpload"> Photo
                </label>
                <span class="text-danger text-sm" v-show="errors.has('personal.applicantPhoto')">{{ errors.first('personal.applicantPhoto') }}</span>
                <!--<input type="file" @change="successAppPhotoUpload">-->
                <!--<template>
                  <vs-upload text="Photo Upload"
                             @on-success="successUpload"/>
                </template>-->
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <!-- @click="updatePersonalInfo()" -->
            <vs-button
              color="success" class="mr-3 mb-2 float-right" @click="savaPersonalInfoifNoError()">Update
            </vs-button>

          </div>
        </div>
      </form>
    </vx-card>
  </div>
</template>
<script>


  import vSelect from 'vue-select'
  import Datepicker from 'vuejs-datepicker'
  import {mapGetters} from 'vuex'
  import {Validator} from 'vee-validate'
  import axios from "../../axios";

  const dict = {
    custom: {
      nid_No: {
        required: 'Nid No is required'
        //alpha: "First name may only contain alphabetic characters"
      }
    }
  }
  export default {
    data () {
      return {
        userInfo: '',
        contactTab: true,
        showNidError: false,
        personal: {
          id:'',
          ekyc_id:'',
          applicantName: '',
          lastName: '',
          fathersName: '',
          motherName: '',
          spouseName: '',
          age: '',
          maritalStatus: '',
          gender: '',
          headOfHousehold: true,
          education: '',
          nidNo: '',
          nidFrontImage: '',
          nidBackImage: '',
          applicantPhoto: ''
        },
        educationLevelOpt: [
          {
            text: 'Below SSC',
            value: 'Bellow SSC'
          },
          {
            text: 'SSC or O Level',
            value: 'SSC or O Level'
          },
          {
            text: 'HSC or A Level',
            value: 'HSC or A Level'
          },
          {
            text: 'Diploma',
            value: 'Diploma'
          },
          {
            text: 'Bachelor\'s ',
            value: 'Bachelor\'s '
          },
          {
            text: 'Master\'s',
            value: 'Master\'s'
          },
          {
            text: 'Doctorate',
            value: 'Doctorate'
          }
        ],
        nidFrontUrl:'',
        nidBackUrl:'',
        applicantPhotoUrl:'',
      }
    },
    created() {
      this.$validator.extend(
        'greaterThanZero',{
          getMessage: field =>  field + ' NID must be 10, 13 or 17 digit.',
          validate: (value) => {

            // value must be > zero
            if (value <= 0 ) {
              this.personal.nidNo = null;
            }
            if (value.toString().length === 10){
              return true;
            }
            else if(value.toString().length === 13){
              return true
            }else if(value.toString().length === 17){
              return true
            }else {
              return false;
            }
          }
        });
    },
    computed: {
      ...mapGetters(['nidDisable']),
    },
    mounted() {
      //this.$store.dispatch('apiLoading', true);
      axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/getApplicantPersonalInfo/`+this.$route.params.ekyc_id).then((response)=>{

        console.log("PersonalInfo = ", response);
        if (response.data.length > 0) {
          this.personal.id = response.data[0].id
          this.personal.ekyc_id = response.data[0].ekyc_id
          this.personal.applicantName = response.data[0].name
          this.personal.lastName = response.data[0].last_name
          this.personal.fathersName = response.data[0].father_name
          this.personal.motherName = response.data[0].mother_name
          this.personal.spouseName = response.data[0].spouse_name
          this.personal.age = response.data[0].age
          this.personal.maritalStatus = response.data[0].marital_status
          this.personal.gender = response.data[0].gender
          this.personal.headOfHousehold = response.data[0].head_of_household
          this.personal.education = response.data[0].education_level
          this.personal.nidNo = response.data[0].nid
          this.nidFrontUrl = response.data[0].nid_front
          this.nidBackUrl = response.data[0].nid_back
          this.applicantPhotoUrl = response.data[0].photo
          if(this.nidFrontUrl){
            fetch(this.nidFrontUrl)
              .then(async response => {
                const contentType = response.headers.get('content-type')
                const blob = await response.blob()
                console.log("BBBBl :", blob.type, contentType)
                const fileFr = new File([blob], this.nidFrontUrl, { contentType })
                this.personal.nidFrontImage = fileFr;
                console.log("BBBB-->> :", fileFr)
              })
          }
          if(this.nidBackUrl){
            fetch(this.nidBackUrl)
              .then(async response => {
                const contentType = response.headers.get('content-type')
                const blob = await response.blob()
                const fileBk = new File([blob], this.nidBackUrl, { contentType })
                this.personal.nidBackImage = fileBk;

              })
          }
          if(this.applicantPhotoUrl){
            fetch(this.applicantPhotoUrl)
              .then(async response => {
                const contentType = response.headers.get('content-type')
                const blob = await response.blob()
                const filePhoto = new File([blob], this.applicantPhotoUrl, { contentType })
                this.personal.applicantPhoto = filePhoto;
              })
          }
        }
        this.$store.dispatch('apiLoading', false);
      });
      console.log("mounted", this.$route.params.ekyc_id)

    },
    methods: {
      savaPersonalInfoifNoError () {
        return new Promise((resolve, reject) => {
          this.$validator.validateAll('step-1').then(result => {
            if (result) {
              resolve(true)
              if (this.personal.nidNo !== null) {
                this.updatePersonalInfo(this.personal)
              }
              this.showNidError = false
            } else {
              reject('correct all values')
              this.showNidError = true
            }
          })
        })
      },
      async updatePersonalInfo (personal) {
        console.log('personal=', personal)
        let formData = new FormData();
        formData.append('id',personal.id);
        formData.append('ekyc_id',personal.ekyc_id);
        formData.append('nidFront',personal.nidFrontImage);
        formData.append('nidBack',personal.nidBackImage);
        formData.append('applicantPhoto',personal.applicantPhoto);
        formData.append('applicantName',personal.applicantName);
        formData.append('lastName',personal.lastName);
        formData.append('fathersName',personal.fathersName);
        formData.append('motherName',personal.motherName);
        formData.append('spouseName',personal.spouseName);
        formData.append('age',personal.age);
        formData.append('maritalStatus',personal.maritalStatus);
        formData.append('gender',personal.gender);
        formData.append('headOfHousehold',personal.headOfHousehold);
        formData.append('education',personal.education);
        formData.append('nidNo',personal.nidNo);
        axios.post(`https://ho.butterflygroupbd.com/showroom-backend/api/updateApplicantPersonalInfo`, formData).then((res) => {
          console.log('Data = ', res.data)
          this.$vs.notify({
            title: 'Success',
            text: 'Personal Information Successfully Updated.',
            color: 'success',
            position: 'top-right'
          });
          window.history.back();
        }).catch((error) => {
          console.log('Contact Error', error)
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: 'danger',
            position: 'top-right'
          })
        })
      },
      /*async updatePersonalInfo (personal) {
        console.log('Update :', personal)
        let varr = {
          id: this.userInfo.ekyc.parsonal.id,
          name: this.personal.applicantName,
          last_name: this.personal.lastName,
          father_name: this.personal.fathersName,
          mother_name: this.personal.motherName,
          spouse_name: this.personal.spouseName,
          age: this.personal.age,
          marital_status: this.personal.maritalStatus,
          gender: this.personal.gender,
          head_of_household: this.personal.headOfHousehold,
          education_level: this.personal.education === null ? '' : this.personal.education.value,
          nid: this.personal.nidNo,
          nid_front: this.personal.nidFrontImage,
          nid_back: this.personal.nidBackImage,
          photo: this.personal.applicantPhoto
        }
        let val = Object.keys(varr)
          .filter((k) => varr[k] != '')
          .reduce((a, k) => ({ ...a, [k]: varr[k] }), {});

        await this.$apollo.mutate({
          mutation: updateApplicantProfile,
          variables: val
        }).then((data) => {
          console.log('Data = ', data)
          this.$router.push('/applicantProfile').catch(() => {
          })
          this.$apollo.queries.user.refetch()
          this.$vs.notify({
            title: 'Success',
            text: 'Your update request pending for approval.',
            color: 'success',
            position: 'top-right'
          })
        }).catch((error) => {
        })
      },*/
      successNidFrontUpload (event) {
        console.log("Upload",event)
        this.personal.nidFrontImage = event.target.files[0];
        this.nidFrontUrl = URL.createObjectURL(this.personal.nidFrontImage);
        console.log("URL",this.nidFrontUrl)
      },
      removeNidFront () {
        this.personal.nidFrontImage = '';
        this.nidFrontUrl = ''
      },
      successNidBackUpload (event) {



        console.log("Upload",event.target.files[0])
        this.personal.nidBackImage = event.target.files[0];
        this.nidBackUrl = URL.createObjectURL(this.personal.nidBackImage);
      },
      removeNidBack () {
        this.personal.nidBackImage = '';
        this.nidBackUrl = ''
      },
      successAppPhotoUpload (event) {
        console.log("Upload",event.target.files[0])
        this.personal.applicantPhoto = event.target.files[0];
        this.applicantPhotoUrl = URL.createObjectURL(this.personal.applicantPhoto);
      },
      removePhoto () {
        this.personal.applicantPhoto = '';
        this.applicantPhotoUrl = ''
      },
      successUpload () {
        this.$vs.notify({
          color: 'success',
          title: 'Upload Success',
          text: 'Photo Successfully Uploaded'
        })
      },
      onlyNidNumber ($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
      onlyNumber ($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
      isLetter (e) {
        let char = String.fromCharCode(e.keyCode)
        if (/^[A-Za-z\' '\.\-]+$/.test(char)) return true
        else e.preventDefault()
      }
    },
    components: {
      //FormWizard,
      //TabContent,
      'v-select': vSelect,
      Datepicker
    }
  }
</script>
<style scoped>
  label.custom-file-upload input[type="file"] {
    display: none;
  }
  label.custom-file-upload-app input[type="file"] {
    display: none;
  }

  label.custom-file-upload {
    border: 1px solid #28c76f;
    padding: 35px 25px;
    border-radius: 6px;
    /*background: url("./assets/images/portrait/small/nidIcon.png")no-repeat, center, center;*/
    background-size: cover;
  }
  label.custom-file-upload-app {
    border: 1px solid #28c76f;
    padding: 35px 25px;
    border-radius: 6px;
    /*background: url("./assets/images/portrait/small/profile.png")no-repeat, center, center;*/
    background-size: cover;
  }
  label.custom-file-upload:hover{
    cursor: pointer;
  }
  label.custom-file-upload-app:hover{
    cursor: pointer;
  }
  .preview-image img {
    border: 1px dotted #28c76f;
    border-radius: 5px;
    width: auto;
    height: 110px;
    padding: 5px;
  }
  .preview-image{
    position: relative;
  }
  .preview-image span {
    position: ABSOLUTE;
    top: 0;
    left: 96px;
    height: 25px;
    width: 25px;
    background: #7367f0;
    text-align: center;
    padding: 5px;
    color: #fff;
    border-radius: 100%;
    font-size: 11px;
    cursor: pointer;
  }
  .preview-image span:hover{
    background: red;
  }
  sup {
    font-size: 16px;
    color: red;
  }
</style>
